import { useQuery } from '@tanstack/react-query';
import Addon from '../models/Addon';

export default function useAddons(isElementary = true) {
  return useQuery(['addons', isElementary ? 'elementary' : 'senior'], () => (
    Addon
      .includes('component')
      .where({ isElementary, isSenior: !isElementary })
      .all()
      .then((res) => res.data)
  ), { placeholderData: [] });
}
